export default __webpack_public_path__ + "d45c45fc55535cc1cc0b63053952bce4.png";